import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export const Styled = styled.div.attrs(() => ({
    className: '!flex !flex-col',
}))`
    color: #ffffff;
    width: 100%;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
    width: 100%;

    ${breakpoint('laptop')`
        overflow: visible;
        max-height: none;
    `};

    &.collapsed {
        max-height: 0px;
        border-top-color: transparent !important;

        ${breakpoint('laptop')`
            width: 25px;
            min-width: 0px;
            height: 100%;
            max-height: auto;
        `};

        .nav-list-item {
            opacity: 0;
            pointer-events: none;
        }
    }

    > div {
        flex: 1;
    }

    .nav-list {
        display: flex;
        flex-direction: column;
        font-weight: 400;

        ${breakpoint('laptop')`
        max-width: 270px;
        `};

        svg {
            width: 22px;

            &.nav-icon {
                margin-right: 15px;
            }
        }
    }

    .nav-list-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        cursor: pointer;
        user-select: none;
        white-space: nowrap;
        transition: opacity 0.3s ease-in-out;
        color: #fff;
        background-color: transparent;
        white-space: normal;

        &:focus,
        &:active {
            outline: none;
        }

        ${breakpoint('laptop')`
            padding: 10px 15px;
        `};

        &.active {
            font-weight: 700;
            color: ${props => props.theme.admin.colors.brand};
        }

        &:hover {
            text-decoration: none;
            color: ${props => props.theme.admin.colors.brand} !important;
        }
    }

    .nav-sublist {
        position: relative;
        padding-left: 40px;
        max-height: 0px;
        overflow: hidden;
        transition: max-height 0.3s ease-in-out;

        ${breakpoint('laptop')`
            padding-left: 40px;
        `};

        &.nav-sublist__active {
            max-height: 1500px;
        }

        &.nav-sublist__lvl2 {
            padding-left: 20px;
            &:before {
                content: none;
            }

            .nav-list-item {
                padding: 5px;
                font-weight: 300;
            }
        }

        &:before {
            content: '';
            width: 2px;
            left: 25px;
            position: absolute;
            background-color: ${props => props.theme.admin.colors.background};
            top: 10px;
            bottom: 10px;
        }

        .nav-list-item {
            padding: 0.4rem 10px;
        }
    }

    .nav-toggle {
        display: none;
        cursor: pointer;
        position: absolute;
        top: 10px;
        right: -12px;
        height: 30px;
        background-color: white;
        justify-content: flex-end;
        align-items: center;
        border-radius: 50%;
        padding: 10px 0 10px 10px;

        ${breakpoint('laptop')`
            display: flex;
        `};
    }

    .menu-icon {
        width: 18px;
        transition: transform 0.1s linear;
        -webkit-transform-origin: 50% 51%;
        transform-origin: 50% 51%;

        &.menu-icon__open {
            transform: rotate(90deg);
        }
    }
`
